import React, { useState } from 'react';
import { Menu, X, Briefcase } from 'lucide-react';
export type ServiceType = 'foretagsbestallning' | 'manadens_meny' | 'catering_event';
interface NavigationProps {
  onOrderClick: (type: ServiceType) => void;
  onJobsClick: () => void;
}
export function Navigation({
  onOrderClick,
  onJobsClick
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleLinkClick = (type: ServiceType) => {
    onOrderClick(type);
    setIsOpen(false);
  };
  const handleJobsClick = () => {
    onJobsClick();
    setIsOpen(false);
  };
  const links: {
    label: string;
    type: ServiceType;
  }[] = [{
    label: 'Företagsbeställning',
    type: 'foretagsbestallning'
  }, {
    label: 'Catering & Event',
    type: 'catering_event'
  }];
  return <nav className="sticky top-0 z-40 w-full bg-[#FFF8F0] border-b border-[#C5A55A]/15 shadow-sm" data-id="element-507">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-508">
        <div className="flex justify-center items-center h-12" data-id="element-509">
          {/* Desktop Menu - Centered */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-510">
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#C5A55A] transition-colors tracking-wide" data-id="element-511">
                {link.label}
              </button>)}
            <button onClick={handleJobsClick} className="flex items-center gap-1.5 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#C5A55A] transition-colors tracking-wide" data-id="element-512">
              <Briefcase className="w-4 h-4" data-id="element-513" />
              Jobba hos oss
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-514">
            <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-[#1A1A1A]/70 hover:bg-[#C5A55A]/10 focus:outline-none transition-colors" aria-label="Meny" aria-expanded={isOpen} data-id="element-515">
              {isOpen ? <X className="h-5 w-5" data-id="element-516" /> : <Menu className="h-5 w-5" data-id="element-517" />}
              <span className="text-sm font-medium tracking-wide" data-id="element-518">
                {isOpen ? 'Stäng' : 'Meny'}
              </span>
            </button>
          </div>
        </div>
      </div>

      {isOpen && <div className="md:hidden bg-[#FFF8F0] border-t border-[#C5A55A]/10 animate-in slide-in-from-top-2 duration-200" data-id="element-519">
          <div className="px-4 pt-3 pb-4 space-y-1" data-id="element-520">
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-521">
              Beställ & Tjänster
            </p>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#C5A55A]/10 hover:text-[#C5A55A] transition-colors" data-id="element-522">
                {link.label}
              </button>)}
            <div className="h-px bg-[#C5A55A]/10 my-2" data-id="element-523" />
            <p className="text-xs text-[#1A1A1A]/40 uppercase tracking-wider font-medium px-3 pb-2" data-id="element-524">
              Karriär
            </p>
            <button onClick={handleJobsClick} className="flex items-center gap-2 w-full text-left px-3 py-3 rounded-lg text-base font-medium text-[#1A1A1A]/70 hover:bg-[#C5A55A]/10 hover:text-[#C5A55A] transition-colors" data-id="element-525">
              <Briefcase className="w-5 h-5" data-id="element-526" />
              Jobba hos oss
            </button>
          </div>
        </div>}
    </nav>;
}